<template>
	<main class="mypage subscription c_responsive">
		<UserMenu v-if="displayStore.isDesktop" />
		<article class="history">
			<h6>구독 내역</h6>
			<div class="c_tabMenu">
				<div
					class="c_tabMenu_item"
					:class="{ on: currentTab === 'ING' }"
					@click="$router.replace({ query: { currentTab: 'ING', page: 1 } })"
				>
					구독중
				</div>
				<div
					class="c_tabMenu_item"
					:class="{ on: currentTab === 'EXP' }"
					@click="$router.replace({ query: { currentTab: 'EXP', page: 1 } })"
				>
					구독만료
				</div>
			</div>
			<div class="history_container">
				<ul class="history_board">
					<li
						v-for="(item, idx) in currentTab === 'ING'
							? memberSubscriptionData?.data.subscription_ing
							: memberSubscriptionData?.data.subscription_exp"
						:key="idx"
						@click="
							$router.push({
								path: `/sub/details/${item.subscription_pk}`,
								query: { currentTab: currentTab },
							})
						"
					>
						<p>{{ item.subscription_goods_name }}</p>
						<p>
							<span>이용기간:</span
							><span
								>{{ dayjs(item.subscription_start_date).format('YYYY-MM-DD') }}~{{
									dayjs(item.subscription_end_date).format('YYYY-MM-DD')
								}}</span
							>
						</p>
					</li>
					<div
						v-if="
							currentTab === 'ING'
								? memberSubscriptionData?.data.subscription_ing_cnt === 0
								: memberSubscriptionData?.data.subscription_exp_cnt === 0
						"
						class="layout_empty"
					>
						<span>{{ currentTab === 'ING' ? '구독 중인 상품이 없습니다.' : '구독 만료 내역이 없습니다.' }}</span>
					</div>
				</ul>
				<Pagination
					v-if="
						currentTab === 'ING'
							? memberSubscriptionData?.data.subscription_ing_cnt
							: memberSubscriptionData?.data.subscription_exp_cnt
					"
					:current-page="Number(route.query.page ?? 1)"
					:total-count="
						currentTab === 'ING'
							? memberSubscriptionData?.data.subscription_ing_cnt
								? Math.ceil(memberSubscriptionData?.data.subscription_ing_cnt / 10)
								: 0
							: memberSubscriptionData?.data.subscription_exp_cnt
								? Math.ceil(memberSubscriptionData?.data.subscription_exp_cnt / 10)
								: 0
					"
					@set-page="(page) => router.replace({ query: { ...route.query, page: page } })"
				/>
			</div>
		</article>
	</main>
</template>

<script setup lang="ts">
// core
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
// library
import dayjs from 'dayjs';

// api
import { useGetMemberSubscriptionApi } from '@/api/mypage';
// component
import Pagination from '@/components/layout/common/Pagination.vue';
import UserMenu from '@/components/mypage/UserMenu.vue';
// store
import { useDisplayStore } from '@/stores/display';

// -----variable-----
const displayStore = useDisplayStore();
const route = useRoute();
const router = useRouter();

const currentTab = computed(() => {
	return (route.query.currentTab ?? 'ING') as string;
});
// -----api-----
const { data: memberSubscriptionData } = useGetMemberSubscriptionApi(
	computed(() => {
		return { state: currentTab.value, page: Number(route.query.page ?? 1), row: 10 };
	})
);
</script>

<style lang="scss" scoped>
.subscription {
	@media screen and (max-width: 1280px) {
		padding: 4rem 0 0 0;
	}
	.history {
		width: 100%;
		height: 100%;
		.history_container {
			margin-bottom: 7.2rem;
			@media screen and (max-width: 1280px) {
				margin-bottom: 8rem;
			}
		}
		.history_board {
			margin-bottom: 1.2rem;
			width: 100%;
			li {
				cursor: pointer;

				width: 100%;
				p {
					max-width: 68rem;
					width: 100%;
					text-overflow: ellipsis;
					white-space: nowrap;
					overflow: hidden;
				}
			}
		}
		.layout_empty {
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: var(--font-s-regular);
			font-weight: 400;
			height: calc(100dvh - var(--header-height) - 20rem - var(--footer-height));
			color: #818393;
			@media screen and (max-width: 1280px) {
				height: initial;
				margin-top: 8rem;
			}
		}
	}
}
</style>
